export default {
  actions: {
    createLocation({ dispatch }, location) {
      // Accepts address or id in location
      return Vue.$http
        .post(`client/organization/locations`, {
          location
        })
        .then(
          ({ data }) => dispatch('fetch', location.organization.id),
          ({ data }) => data.errors || data.error
        )
    },
    removeLocation({ dispatch }, location) {
      return Vue.$http
        .delete(`client/organization/locations/${location.id}`)
        .then(() => dispatch('fetch', location.organization.id))
    }
  }
}
